// extracted by mini-css-extract-plugin
export default {"root":"Header_root__33tbG","logo":"Header_logo__Ln+XZ"};